import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ui } from '@/constants';
import { Menu, RecentOrFavoriteEntree, RecentOrFavoriteOrder } from '@/models';
import moment from 'moment';

@Component({
  name: 'CmgOneTapReorderDetailsModal',
})
export default class CmgOneTapReorderDetailsModal extends Vue {
  isSaving = false;
  orders: RecentOrFavoriteOrder[] = [];
  currentRecentOrder: RecentOrFavoriteOrder | null = null;

  get visible(): boolean {
    return this.$appStore.state.ui.modals.oneTapReorderDetailsModal.visible;
  }

  get args() {
    return this.$appStore.state.ui.modals.oneTapReorderDetailsModal.args;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  get entree(): RecentOrFavoriteEntree | undefined {
    return this.args?.entree;
  }
  
  get menu(): Menu | null {
    return this.$appStore.state.menu.activeMenu;
  }

  get orderDate(): string {
    return this.args?.orderDate || '';
  }

  get entreeContents(): string[] {
    if (!this.menu || !this.entree) {
      return [];
    }

    return this.$services.entree.getIndividualContentDetails(this.entree, this.menu);
  }

  onCancel() {
    this.close();
  }

  async onAddToBag() {
    if (this.args) {
      this.isSaving = true;

      try {
        this.args.onAddToBag();
        this.close();
      } finally {
        this.isSaving = false;
      }
    }
  }

  private close() {
    this.$services.ui.setModalVisibility('oneTapReorderDetailsModal', false);
    this.$services.ui.focusBack();
  }
}
